import { render, staticRenderFns } from "./SegmentDelivery.vue?vue&type=template&id=288aa54c&scoped=true&"
import script from "./SegmentDelivery.vue?vue&type=script&lang=js&"
export * from "./SegmentDelivery.vue?vue&type=script&lang=js&"
import style0 from "./SegmentDelivery.vue?vue&type=style&index=0&id=288aa54c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288aa54c",
  null
  
)

export default component.exports